"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBreadcrumbsSchema = void 0;

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.concat.js");

var _withContext = require("./withContext");

var _url = require("../constants/url");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getBreadcrumbsSchema = function getBreadcrumbsSchema(items) {
  return _objectSpread(_objectSpread({}, _withContext.withContext), {}, {
    '@type': 'BreadcrumbList',
    itemListElement: items.map(function (item, i) {
      return _objectSpread({
        '@type': 'ListItem',
        position: i + 1,
        name: item === null || item === void 0 ? void 0 : item.label
      }, (item === null || item === void 0 ? void 0 : item.to) && {
        item: "".concat(_url.ZOLA_DOMAIN).concat(item === null || item === void 0 ? void 0 : item.to)
      });
    })
  });
};

exports.getBreadcrumbsSchema = getBreadcrumbsSchema;